<bw-action-article-legacy [brightsideWebFb]="{event_name: 'hardship_required_docs'}">
  <div header-actions>
    <ui-nav-exit-back
      [trackingDetail]="{ event_name: 'hardship_required_docs' }"
    ></ui-nav-exit-back>
  </div>
  <div header-title>
    <typography-legacy title-large color="var(--primary-text)">
      {{ 'HARDSHIP_REQUIRED_DOCUMENTS_TITLE' | translate }}
    </typography-legacy>
  </div>
  <div content-section>
    <bw-paragraph-legacy>
      {{ 'HARDSHIP_CONFIRM_REQUEST_DESC' | translate }}
    </bw-paragraph-legacy>

    @if (routeAction === 'confirm-request') {
      @if (hardshipRequiredDocsService.qualifiersVm(); as qualifiers) {
        @for (qualifier of qualifiers; track qualifier.key) {
          <h3>{{ qualifier.title | translate }}</h3>

          @for (doc of qualifier.qualifyingDocuments; track doc.id) {
            <bw-hardship-required-docs-card
              [cardInfo]="doc"
              (click)="cardActions[doc.state](doc)"
            ></bw-hardship-required-docs-card>
          }
        }
      } @else {
        <bw-spinner-legacy></bw-spinner-legacy>
      }
    } @else if (routeAction === 'submit') {
      <section>
        <h3>Additional Documents</h3>
        @if (hardshipRequiredDocsService.allDocumentsVm(); as docs) {
          @if (docs.length === 0 || hardshipRequiredDocsService.processing()) {
            <bw-spinner-legacy></bw-spinner-legacy>
          } @else {
            <div class="docs-grid">
              @for (doc of docs; track doc) {
                <bw-hardship-required-docs-card
                  [cardInfo]="doc"
                  (click)="cardActions[doc.state](doc)"
                ></bw-hardship-required-docs-card>
              }
            </div>
          }
        }
      </section>
    }
  </div>
  <div footer-actions>
    <button
      bw-button-legacy
      [disabled]="!hardshipRequiredDocsService.canReview() || hardshipRequiredDocsService.processing()"
      [processing]="hardshipRequiredDocsService.processing()"
      [brightsideWebFb]="{event_name: 'hardship_required_docs'}"
      (click)="routeUser();">
      @if (routeAction === 'confirm-request') {
        {{ 'HARDSHIP_REQUIRED_DOCUMENTS_CTA' | translate }}
      } @else if (routeAction === 'submit') {
        {{ 'HARDSHIP_ADDITIONAL_DOCUMENTS_CTA' | translate }}
      }
    </button>
  </div>

</bw-action-article-legacy>
